import { OSKIconDefinition } from '../osk-icon.types';

export const oskIconChevronLeft: OSKIconDefinition = {
  name: 'chevron-left',
  content: '<path d="m15 18-6-6 6-6" />'
};
